export function imgSizeSet(url,size) {
	if (!url) return null
	let r = new RegExp("([.]_).*?(_[.])");
	if (url.indexOf('media-amazon.com') !== -1){
		if (r.test(url)){
			return url.replace(r,('._AC_SS' + size + '_.'))
		}else {
			let s = url.slice(url.lastIndexOf("."));
			return url.substring(0,url.lastIndexOf('.')) + '._AC_SS' + size + '_' + s
		}
	}else {
		return url;
	}
}